module.exports = __webpack_public_path__ + "static/img/review-like.7f6978d7.svg";